import { ReactNode, RefObject, useCallback, useEffect, useRef, useState } from "react"

interface IUseClampedParams {
    textRef: RefObject<HTMLElement | null>
    children: ReactNode
}

export default function useClamped({
    textRef,
    children,
}: IUseClampedParams) {
    const [isClamped, setIsClamped] = useState(false)


    const handleResize = useCallback(() => {
        setIsClamped((!!textRef.current && (
            textRef.current.scrollWidth > textRef.current.clientWidth
            || textRef.current.scrollHeight > textRef.current.clientHeight
        )) || false)
    }, [textRef])

    const observer = useRef(new ResizeObserver(handleResize))

    useEffect(() => {
        if (!textRef.current) return
        observer.current.observe(textRef.current)
        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            observer.current.disconnect()
        }
    }, [handleResize, textRef, children])

    return {
        isClamped,
    }
}
